
import { ProcessAnalysisResponse, GenerateTitleResponse } from '@/types/sections';
import { API_CLARA_LLM_BASE_URL } from '@/config/api';

export const processAnalysis = async (
  analysisId: string,
  lang: string,
  jwt: string,
  userEmail: string,
  signal?: AbortSignal
): Promise<any> => {
  const response = await fetch(`${API_CLARA_LLM_BASE_URL}/process-analysis`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      inputs: {
        analysisId,
        lang,
      },
      query: "Run the analysis.",
      token: jwt,
      user: userEmail,
    }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Process analysis failed: ${response.statusText}`);
  }

  return response.json();
};

export const generateTitle = async (
  lang: string,
  transcript: string,
  jwt: string,
  userEmail: string,
  signal?: AbortSignal
): Promise<any> => {
  const response = await fetch(`${API_CLARA_LLM_BASE_URL}/generate-title`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      lang,
      transcript,
      token: jwt,
      user: userEmail,
    }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Generate title failed: ${response.statusText}`);
  }

  return response.json();
};
